import { jsx as s } from "react/jsx-runtime";
import { forwardRef as p } from "react";
import * as o from "@radix-ui/react-tooltip";
const m = o.Provider, T = o.Portal, x = o.Root, f = o.Trigger, i = p(
  (t, r) => {
    const { onClick: n, className: l = "", ...c } = t, a = (e) => {
      n && (e.preventDefault(), n(e));
    };
    return /* @__PURE__ */ s(
      o.TooltipContent,
      {
        className: `z-40 max-w-56 rounded-xl bg-black px-3 py-2 text-center text-xs text-white ${l}`,
        ref: r,
        onClick: a,
        ...c
      }
    );
  }
);
i.displayName = "TooltipContent";
const C = (t) => {
  const { className: r = "" } = t;
  return /* @__PURE__ */ s(o.Arrow, { className: `z-40 fill-black ${r}` });
}, P = m, w = T, k = x, u = f, v = i, N = C;
export {
  N as Arrow,
  v as Content,
  w as Portal,
  P as Provider,
  k as Root,
  x as Tooltip,
  C as TooltipArrow,
  i as TooltipContent,
  T as TooltipPortal,
  m as TooltipProvider,
  f as TooltipTrigger,
  u as Trigger
};
